module.exports = __webpack_public_path__ + "static/media/ToggleOffIcon.c2e8ff76.svg";